"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ProfunctorState = /** @class */ (function () {
    function ProfunctorState(state, setState) {
        var _this = this;
        this.state = state;
        this.setState = setState;
        this.promap = function (a, b, c) {
            var get = typeof a === 'object' ? a.get : a;
            var set = typeof a === 'object' ? a.set : b;
            var args = typeof a === 'object' ? b : c;
            var innerSetState = function (newInnerStateOrUpdate) {
                _this.setState(function (prevState) {
                    var innerState = get(prevState);
                    var newInnerState = typeof newInnerStateOrUpdate === 'function'
                        ? newInnerStateOrUpdate(innerState)
                        : newInnerStateOrUpdate;
                    if (newInnerState === innerState)
                        return prevState;
                    return set(newInnerState, prevState);
                });
            };
            var innerState = get(_this.state);
            return useMemoizedProfunctorState(innerState, innerSetState, args);
        };
    }
    return ProfunctorState;
}());
exports.ProfunctorState = ProfunctorState;
function useMemoizedProfunctorState(state, setState, args) {
    return react_1.useMemo(function () { return new ProfunctorState(state, setState); }, args ? args : [state]);
}
function useProfunctorState(initial, args) {
    var _a = react_1.useState(initial), state = _a[0], setState = _a[1];
    return useMemoizedProfunctorState(state, setState, args);
}
exports.useProfunctorState = useProfunctorState;
function withProfunctorState(Component, initial, args) {
    function WPS() {
        var prof = useProfunctorState(initial, args);
        return react_1.createElement(Component, prof);
    }
    WPS.displayName =
        'WithProfunctorState(' +
            (Component.displayName || Component.name || 'Component') +
            ')';
    return WPS;
}
exports.withProfunctorState = withProfunctorState;
exports.default = useProfunctorState;
//# sourceMappingURL=index.js.map